export const convertCurrencyStringToNumber = (currencyString: string, zeroIfFalsy = true): number => {
  if (zeroIfFalsy && !currencyString) return 0;

  const value = parseFloat(currencyString?.replace(/,/, '.'));

  return value;
};
